<template>
  <div class="w-64 bg-gray-900 text-white flex flex-col">
    <!-- Logo -->
    <div class="px-6 py-6 border-b border-gray-800">
      <div class="flex items-center space-x-3">
        <div class="bg-blue-600 rounded-lg p-2">
          <CloudIcon class="h-6 w-6 text-white" />
        </div>
        <div>
          <h2 class="text-lg font-bold">Cloudflare</h2>
          <p class="text-xs text-gray-400">Tools</p>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
      <router-link
        v-for="item in menuItems"
        :key="item.name"
        :to="item.path"
        class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors"
        :class="isActive(item.path) ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'"
      >
        <component :is="item.icon" class="h-5 w-5" />
        <span>{{ item.label }}</span>
      </router-link>
    </nav>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-800">
      <div class="text-xs text-gray-500">
        <p>Cloudflare Web Tools</p>
        <p class="mt-1">v1.0.0</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18nStore } from '../../stores/i18n';
import {
  CloudIcon,
  HomeIcon,
  GlobeAltIcon,
  ShieldCheckIcon,
  LockClosedIcon,
  RocketLaunchIcon,
  BoltIcon,
  PlusCircleIcon,
  LinkIcon,
  QueueListIcon,
  ArrowsRightLeftIcon,
} from '@heroicons/vue/24/outline';

const route = useRoute();
const i18n = useI18nStore();

const menuItems = computed(() => [
  {
    name: 'dashboard',
    label: i18n.t('console.dashboard'),
    path: '/console',
    icon: HomeIcon,
  },
  {
    name: 'dns',
    label: i18n.t('console.dns'),
    path: '/console/dns',
    icon: GlobeAltIcon,
  },
  {
    name: 'dns-batch',
    label: i18n.t('console.dnsBatch'),
    path: '/console/dns-batch',
    icon: RocketLaunchIcon,
  },
  {
    name: 'ssl',
    label: i18n.t('console.ssl'),
    path: '/console/ssl',
    icon: LockClosedIcon,
  },
  {
    name: 'ssl-batch',
    label: i18n.t('console.sslBatch'),
    path: '/console/ssl-batch',
    icon: BoltIcon,
  },
  {
    name: 'security',
    label: i18n.t('console.security'),
    path: '/console/security',
    icon: ShieldCheckIcon,
  },
  {
    name: 'rules',
    label: i18n.t('console.rules'),
    path: '/console/rules',
    icon: QueueListIcon,
  },
  {
    name: 'www-redirect',
    label: i18n.t('console.wwwRedirect'),
    path: '/console/www-redirect',
    icon: ArrowsRightLeftIcon,
  },
  {
    name: 'domain-batch',
    label: i18n.t('console.domainBatch'),
    path: '/console/domain-batch',
    icon: PlusCircleIcon,
  },
  {
    name: 'workers-batch',
    label: i18n.t('console.workersBatch'),
    path: '/console/workers-batch',
    icon: LinkIcon,
  },
]);

const isActive = (path) => {
  if (path === '/console') {
    return route.path === '/console' || route.path === '/dashboard';
  }

  return route.path === path || route.path.startsWith(`${path}/`);
};
</script>
